import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    try {
      const res = await api.me();
      setUser(res.data.user);
      setTenant(res.data.tenant);
    } catch {
      setUser(null);
      setTenant(null);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      await refreshMe();
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [refreshMe]);

  const login = useCallback(async (email, password) => {
    // Cookie is set by the backend response — no localStorage.
    await api.login(email, password);
    await refreshMe();
  }, [refreshMe]);

  const logout = useCallback(async () => {
    try { await api.logout(); } catch { /* best-effort */ }
    setUser(null);
    setTenant(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, tenant, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
